import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { clearAuth, getStoredUser, persistAuth } from "../../shared/auth/storage";
import { SESSION_EXPIRED_EVENT } from "../../shared/api/axios";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => getStoredUser());

  useEffect(() => {
    const handleExpired = () => setUser(null);
    window.addEventListener(SESSION_EXPIRED_EVENT, handleExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handleExpired);
  }, []);

  const value = useMemo(
    () => ({
      user,
      isAuthenticated: Boolean(user),
      login: ({ token, user: nextUser }) => {
        persistAuth({ token, user: nextUser });
        setUser(nextUser);
      },
      logout: () => {
        clearAuth();
        setUser(null);
      },
    }),
    [user],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth deve ser usado dentro de AuthProvider");
  }
  return ctx;
}
